import { render } from "./VoteStars.vue?vue&type=template&id=08b51d1c&scoped=true"
import script from "./VoteStars.vue?vue&type=script&lang=js"
export * from "./VoteStars.vue?vue&type=script&lang=js"

import "./VoteStars.vue?vue&type=style&index=0&id=08b51d1c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b51d1c"]])

export default __exports__